import { find, findAll, register } from '../../../../Javascript/Sysmex/Utils'

const ModalTrigger = el => {
  const identifier = el.dataset.identifier
  const container = find(`[data-container-identifier="${identifier}"]`)

  if (container) {
    el.addEventListener('click', open.bind(this, container))

    const overlays = findAll('.sysmexMoleculeModalContainer_background')
    if (overlays) {
      overlays.forEach(bg => {
        bg.addEventListener('click', close.bind(this, container))
      })
    }

    const closeIcons = findAll('.sysmexMoleculeModalContainer_close')
    closeIcons.forEach(icon => {
      icon.addEventListener('click', close.bind(this, container))
    })
  }
}

const open = (container, event) => {
  container.classList.add('sysmexMoleculeModalContainer_modalContainer__active')
}

const close = (container, event) => {
  container.classList.remove('sysmexMoleculeModalContainer_modalContainer__active')
}

register('ModalTrigger', ModalTrigger)
